import React from 'react'
import ListGroup from 'react-bootstrap/ListGroup';
import { useNavigate } from 'react-router-dom'
import Button from 'react-bootstrap/Button';

const InfoProyecto = ({proyectoActivo}) => {



  const navigate = useNavigate();
  const navegarTo = (destino) => {
    const destinourl = '/detalleproyectos/' + destino;
    navigate(destinourl);
}   
   /*
        
       

        aval1_nombre
        aval1_dni
        aval2_nombre
        aval2_dni
        aval3_nombre
        aval3_dni
        aval4_nombre
        aval4_dni
        aval5_nombre
        aval5_dni
        titulo_proyecto
        localidad_proyecto
        descripcion_proyecto
        diagnostico
        objetivo_general
        objetivos_especificos
        antecedentes_fundamentacion
        beneficiarios_destinatarios
        localizacion
        acciones_y_tareas
        recursos_humanos
        recursos_materiales
        recursos_financieros
        monto_total_estimado
        imagen_destacada
        imagen1_url
        imagen1_nombre
        imagen2_url
        imagen2_nombre
        imagen3_url
        imagen3_nombre
        documento_pdf
        documento_nombre
   */ 


  //console.log(proyectoActivo)
  return (
    <>
        <ListGroup variant="flush" style={{lineHeight:'30px'}}>   
            <ListGroup.Item >                  

            {proyectoActivo.id_proyecto !==0 && 
            <>
            <strong>Número de proyecto: </strong> {proyectoActivo.id_proyecto} <br/>
            </>
            }               

            {proyectoActivo.estado ==="Borrador" && 
            <>
                <strong>Estado: </strong> {proyectoActivo.estado}<br/>
                <strong>Fecha de última modificación: </strong> {proyectoActivo.fecha_borrador}<br/>
            </>
            }    
            </ListGroup.Item>                        
            {proyectoActivo.estado ==="Presentado" && 
            <>
            <ListGroup.Item><strong>Estado: </strong> {proyectoActivo.estado}. El proyecto se encuentra en la etapa de revisión</ListGroup.Item> 
            <ListGroup.Item><strong>Fecha de entrega: </strong> {proyectoActivo.fecha_entrega}</ListGroup.Item> 
            </>
            }  
            <ListGroup.Item>
            <strong>Categoría del proyecto: </strong>{proyectoActivo.categoria_proyecto} <br/>
            <strong>Tipo de proyecto: </strong>{proyectoActivo.tipo_proyecto}<br/>
            <strong>Nombre grupo / institución / Comisión Barrial: </strong>{proyectoActivo.nombre_grupo}<br/>
            </ListGroup.Item>
            <ListGroup.Item>
            <Button onClick={()=>navegarTo(proyectoActivo.id_proyecto)}>Ver detalles del proyecto</Button>
            </ListGroup.Item>
        
        
            
            
      </ListGroup>
    </>
  )
}

export default InfoProyecto



